import { Observable } from 'rxjs';
import { auditTime, map } from 'rxjs/operators';

export function isWasmSupported(): boolean {
  try {
    if (typeof WebAssembly === 'object' &&
          typeof WebAssembly.instantiate === 'function') {
      const module = new WebAssembly.Module(Uint8Array.of(
        0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00
      ));

      if (module instanceof WebAssembly.Module) {
        return new WebAssembly.Instance(module) instanceof WebAssembly.Instance;
      }
    }
  } catch (e) { }

  return false;
}

export function isBrowserSupported(): boolean {
  return typeof Uint8ClampedArray !== 'undefined' &&
    typeof Worker !== 'undefined' &&
    typeof ImageData !== 'undefined' &&
    typeof window !== 'undefined' &&
    !!window.Worker;
}

let supportsResizeObserver = false;

if (typeof window !== 'undefined') {
  supportsResizeObserver = 'ResizeObserver' in window;
}

function isElementOverflow(host: HTMLElement): boolean {
  // Don't access the `offsetWidth` multipe times since it triggers layout updates.
  const hostOffsetWidth = host.offsetWidth;

  return hostOffsetWidth > host.parentElement!.offsetWidth || hostOffsetWidth < host.scrollWidth;
}

export function dimensionsChanges(target: HTMLElement) {
  return resizeObserverStrategy(target);
}

function resizeObserverStrategy(target: HTMLElement): Observable<boolean> {
  return new Observable(subscriber => {
    if (!supportsResizeObserver) {
      subscriber.next(true);
      subscriber.complete();

      return;
    }

    const observer = new ResizeObserver(() => subscriber.next(true));
    
    observer.observe(target);

    return () => observer.disconnect();
  });
}